import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Handshake } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

export function ContractorBlock({ data, onChanged }) {
  const c = data.contractor;
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ contractor_name: "", contractor_cnpj: "" });
  const start = () => { setForm({ contractor_name: c?.name || "", contractor_cnpj: c?.cnpj || "" }); setOpen(true); };
  const save = async (body) => {
    try { await api.put(`/viagens/${data.viagem.id}/contractor`, body); toast.success("Contratante atualizada nesta viagem"); setOpen(false); onChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };
  return (
    <div className="border rounded-md p-3 bg-blue-50/60 border-blue-200" data-testid="acerto-contractor-block">
      <div className="text-xs uppercase tracking-wider text-blue-700 flex items-center gap-1"><Handshake size={12} /> Contratante</div>
      {c ? (
        <>
          <div className="font-bold text-slate-900 mt-0.5" data-testid="acerto-contractor-name">{c.name}</div>
          <div className="text-xs text-slate-600">CNPJ: {c.cnpj || "-"}</div>
        </>
      ) : (
        <div className="text-xs text-slate-600 mt-1">Não informada. <Link to="/autonomo/perfil" className="text-blue-700 underline print:hidden">Cadastrar no Perfil</Link></div>
      )}
      <button type="button" onClick={start} data-testid="btn-change-contractor" className="print:hidden text-xs text-blue-700 underline mt-1" data-html2canvas-ignore="true">
        {c?.source === "viagem" ? "Alterar nesta viagem" : "Trocar só nesta viagem"}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" aria-describedby={undefined} data-testid="contractor-dialog">
          <DialogHeader><DialogTitle>Contratante desta viagem</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Empresa para quem prestou o serviço</Label><Input value={form.contractor_name} onChange={(e) => setForm({ ...form, contractor_name: e.target.value })} data-testid="contractor-name-input" /></div>
            <div><Label>CNPJ</Label><Input value={form.contractor_cnpj} onChange={(e) => setForm({ ...form, contractor_cnpj: e.target.value })} data-testid="contractor-cnpj-input" /></div>
            {c?.source === "viagem" && <Button type="button" variant="outline" className="w-full" onClick={() => save({ contractor_name: "", contractor_cnpj: "" })} data-testid="btn-contractor-reset">Voltar a usar a do Perfil</Button>}
          </div>
          <DialogFooter><Button onClick={() => save(form)} data-testid="btn-save-contractor" className="bg-blue-600 hover:bg-blue-700 text-white">Salvar</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
